import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { FiEdit } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { useGrupoPizza } from '../../../../../../../hooks/grupoPizza';
import { useToast } from '../../../../../../../hooks/toast';
import { useAuth } from '../../../../../../../hooks/auth';

import api from '../../../../../../../services/api';

import {
  DrawerTabTitle,
  TabWrapper,
  TamanhoItem,
  ButtonAction,
} from '../../../drawer_styles';
import { SubmitButtonWrapper } from '../../../../styles';

const Tamanhos: React.FC = () => {
  const { addToast } = useToast();
  const { user } = useAuth();

  const [tamanhos, setTamanhos] = useState<any[]>([]);

  const {
    changeCurrentTabIndex,
    enableComplementos,
    resetDrawer,
  } = useGrupoPizza();

  const handleSubmit = useCallback(() => {
    enableComplementos();
    changeCurrentTabIndex(2);
  }, [enableComplementos, changeCurrentTabIndex]);

  useEffect(() => {
    async function loadTamanhos(): Promise<void> {
      try {
        const response = await api.get('/tamanho');

        const parsedTamanhos: any[] = [];

        response.data.forEach((tamanho: any) => {
          if (tamanho.ativo) {
            parsedTamanhos.push({
              id: tamanho.id,
              descricao: tamanho.descricao,
              numberOfFlavors: tamanho.qtd_sabores,
              numberOfSlices: tamanho.qtd_pedacos,
              ordem: tamanho.ordem,
            });
          }
        });

        if (parsedTamanhos.length > 0) {
          setTamanhos(parsedTamanhos);

          return;
        }

        addToast({
          title: 'Aguarde',
          type: 'info',
          description: 'Seus novos tamanhos estão sendo criados',
        });

        const initialTamanhos = [
          {
            id: 1,
            descricao: 'Pequena',
            numberOfFlavors: 1,
            numberOfSlices: 1,
          },
          {
            id: 2,
            descricao: 'Média',
            numberOfFlavors: 2,
            numberOfSlices: 6,
          },
          {
            id: 3,
            descricao: 'Grande',
            numberOfFlavors: 3,
            numberOfSlices: 8,
          },
        ];

        const newTamanhos: any[] = [];

        await Promise.all(
          initialTamanhos.map(async (tamanho) => {
            const newTamanho = await api.post('/tamanho', {
              descricao: tamanho.descricao,
              ordem: 1,
              qtd_pedacos: tamanho.numberOfSlices,
              ativo: true,
              tipo: 3,
              qtd_sabores: tamanho.numberOfFlavors,
              empresa_id: user.empresa_id,
            });

            newTamanhos.push({
              id: newTamanho.data.id,
              descricao: newTamanho.data.descricao,
              numberOfFlavors: newTamanho.data.qtd_sabores,
              numberOfSlices: newTamanho.data.qtd_pedacos,
              ordem: newTamanho.data.ordem,
            });
          }),
        );

        setTamanhos(newTamanhos);
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description: err.response?.data?.message || 'Tente novamente.',
        });
      }
    }

    loadTamanhos();
  }, [user.empresa_id, addToast]);

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Tamanhos</h1>
        <span>
          Veja aqui quais os tamanhos que suas pizzas são produzidas, em quantos
          pedaços são cortadas e até quantos sabores seu restaurante monta cada
          tamanho:
        </span>
      </DrawerTabTitle>
      <Grid container>
        <Grid container>
          <Grid item xs={2}>
            <p>Nome</p>
          </Grid>
          <Grid item xs={3}>
            <p>Qtd. Pedaços</p>
          </Grid>
          <Grid item xs={3}>
            <p>Qtd. Sabores</p>
          </Grid>
        </Grid>
        <Grid container>
          {tamanhos
            .sort((a, b) => a.ordem - b.ordem)
            .map((tamanho) => (
              <TamanhoItem key={tamanho.id}>
                <Grid item xs={2}>
                  <hr style={{ marginBottom: 15 }} />
                  <strong>{tamanho.descricao}</strong>
                </Grid>
                <Grid item xs={3}>
                  <hr style={{ marginBottom: 15 }} />
                  <strong style={{ marginLeft: 40 }}>
                    {tamanho.numberOfSlices}
                  </strong>
                </Grid>
                <Grid item xs={3}>
                  <hr style={{ marginBottom: 15 }} />
                  <strong style={{ marginLeft: 40 }}>
                    {tamanho.numberOfFlavors}
                  </strong>
                </Grid>
              </TamanhoItem>
            ))}
        </Grid>
        <Grid item xs={3} style={{ marginTop: 15, marginBottom: 50 }}>
          <Link to="/configuracoes/6" style={{ color: '#2979ff' }}>
            <FiEdit size={15} />
            Editar tamanhos
          </Link>
        </Grid>
        <Grid item xs={12}>
          <SubmitButtonWrapper>
            <ButtonAction
              type="button"
              className="cancel"
              onClick={resetDrawer}
            >
              Cancelar
            </ButtonAction>
            <ButtonAction
              type="button"
              className="submit"
              id="submit_button"
              onClick={handleSubmit}
            >
              Continuar
            </ButtonAction>
          </SubmitButtonWrapper>
        </Grid>
      </Grid>
    </TabWrapper>
  );
};

export default Tamanhos;
